/**
 * The customer, as two letters.
 *
 * **No photograph and no upload.** The product never asks a customer for one, so the alternative to
 * initials is a stock silhouette on every account — which says nothing and looks like a field
 * somebody forgot to fill in. Initials at least belong to the person.
 *
 * A name that yields no letters — an account created from a telephone number alone, which is a
 * supported case — falls back to the brand mark rather than to an empty circle.
 */
export function Avatar({ name, className = 'size-10' }: { name: string; className?: string }) {
    const initials = name
        .split(/\s+/)
        .filter((part) => part.length > 0)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() ?? '')
        .join('');

    if (initials.length === 0) {
        return (
            <span
                aria-hidden="true"
                className={`flex shrink-0 items-center justify-center rounded-full bg-brand-600 ${className}`}
            >
                <img src="/favicon.ico" alt="" className="h-3/5 w-3/5" />
            </span>
        );
    }

    return (
        <span
            aria-hidden="true"
            className={`flex shrink-0 items-center justify-center rounded-full bg-brand-100 font-bold text-brand-800 dark:bg-brand-900 dark:text-brand-200 ${className}`}
        >
            {initials}
        </span>
    );
}
